import EndPoint from 'Api/EndPoint';
import Client from 'Api/Client';

export const UPLOAD_TYPE = {
  INTERNAL_NOTICE: 'INTERNAL_NOTICE',
  PRIVATE_NOTE: 'PRIVATE_NOTE',
  CUSTOMER_SUPPORT_CHAT: 'CUSTOMER_SUPPORT_CHAT',
};

export async function uploadFile(type, file, onProgress = null, signal = null) {
  return await Client.uploadFileV2(`${EndPoint.Upload}`, type, file, onProgress, signal);
}
